import './TableRow.scss';

import classNames from 'classnames';

import tableColumns from '../../TableColumns';
import TableListColumn from '../TableListColumn';

function TableRow({
  item,
  isLoading,
  columnsOrder,
  rowsBgColor,
  index,
  onClick,
  columns,
}) {
  const getBgColor = () => {
    if (rowsBgColor) {
      if (index % 2 === 0) {
        return 'b-white';
      } else {
        return 'b-light-orange';
      }
    }
  };
  const content = columnsOrder.map((name) => (
    <TableListColumn
      key={name}
      isLoading={isLoading}
      id={name}
      item={item}
      component={tableColumns[name]}
      column={columns.filter((column) => column.key === name)[0]}
    />
  ));

  return (
    <div
      role="button"
      tabIndex={0}
      className={classNames(
        'table-list-item flex-row f11',
        getBgColor(),
        onClick && 'pointer'
      )}
      onClick={() => {
        if (onClick) onClick(item);
      }}
    >
      {content}
    </div>
  );
}

export default TableRow;
